import React, { Fragment } from "react";
import Lottie from "react-lottie";
import * as pinTrue from "./pinTrue.json";

function PinTrue() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: pinTrue.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Fragment>
      <Lottie options={defaultOptions} width={200} height={200} />
    </Fragment>
  );
}

export default PinTrue;
